import React from "react";
import { Link } from "react-router-dom";
import classes from "./Controls.module.css";

const Controls = (props) => {
  return (
    <section className={classes.Controls}>
      <Link className={classes.Back} to={props.to}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        Zurück
      </Link>

      {props.date ? <span className={classes.Date}>{props.date}</span> : null}
    </section>
  );
};

export default Controls;
